import {
  darkColors,
  lightColors,
  radii,
  spacing,
  type ThemeName,
} from "@plotlounge/design-tokens";

function kebab(name: string): string {
  return name.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`);
}

function colorVars(theme: ThemeName): string {
  const palette = theme === "dark" ? darkColors : lightColors;
  return Object.entries(palette)
    .map(([key, value]) => `  --pl-color-${kebab(key)}: ${value};`)
    .join("\n");
}

function spacingVars(): string {
  return Object.entries(spacing)
    .map(([key, value]) => `  --pl-space-${key}: ${value}px;`)
    .join("\n");
}

function radiiVars(): string {
  return Object.entries(radii)
    .map(([key, value]) => `  --pl-radius-${kebab(key)}: ${value}px;`)
    .join("\n");
}

/**
 * Emits a stylesheet that exposes every design token as a CSS custom
 * property. SCSS modules reference these via `var(--pl-color-foreground)`
 * etc., so the JS tokens remain the single source of truth.
 */
export function buildTokenStylesheet(): string {
  return [
    `:root[data-theme="light"] {`,
    colorVars("light"),
    spacingVars(),
    radiiVars(),
    `}`,
    `:root[data-theme="dark"] {`,
    colorVars("dark"),
    spacingVars(),
    radiiVars(),
    `}`,
    `:root {`,
    colorVars("light"),
    spacingVars(),
    radiiVars(),
    `}`,
  ].join("\n");
}

export function installTokenStylesheet(): void {
  const id = "plotlounge-design-tokens";
  if (document.getElementById(id)) return;
  const style = document.createElement("style");
  style.id = id;
  style.textContent = buildTokenStylesheet();
  document.head.appendChild(style);
}
